import React from 'react';
import Button from 'react-bootstrap/Button';

interface IconLinkProps {
    lien?: string;
    ariaLabel: string;
    iconClass: string;
    title: string;
    targetLink?: string;
    onClick?: (e: any) => void;
}

function IconeService({lien, ariaLabel, iconClass, title, targetLink, onClick}: IconLinkProps) {
    return (
        <Button
            onClick={onClick}
            href={lien}
            target={targetLink}
            aria-label={ariaLabel}
            style={{
                margin: '0.5rem',
                backgroundColor: '#1e1e3f',
                padding: '0.35rem',
            }}
        >
            <i
                className={iconClass}
                aria-hidden="true"
                title={title}
                style={{padding: '0.35rem'}}
            ></i>
        </Button>
    );
}

export default IconeService;
